import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Header, Footer } from "../components/layout";
import { AuthModal, KickstarterSubscribeModal } from "../components/modals";
import {
  HeroSection,
  FeaturesSection,
  HowItWorksSection,
  KickstarterSection,
  CarriersSection,
  FAQSection,
  EcoSection,
  ProblemSolutionSection,
  SocialFollowSection,
  StickyBottomBar,
} from "../components/landing";
import { trackEvent } from "../hooks/useAnalytics";

const LandingPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [kickstarterModalOpen, setKickstarterModalOpen] = useState(false);

  const handleNotifyClick = () => {
    trackEvent("click_kickstarter_notify", window.location.pathname, { user_logged_in: !!user });
    setKickstarterModalOpen(true);
  };

  const handleLoginClick = () => {
    trackEvent("click_login", window.location.pathname);
    setAuthModalOpen(true);
  };

  const handleAuthSuccess = () => {
    trackEvent("auth_success", window.location.pathname);
    setAuthModalOpen(false);
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen pb-48 md:pb-0 landing-page-container" data-testid="landing-page">
      <Header onPreorderClick={handleNotifyClick} onLoginClick={handleLoginClick} />
      <HeroSection onPreorderClick={handleNotifyClick} />
      <SocialFollowSection />
      <ProblemSolutionSection />
      <FeaturesSection />
      <HowItWorksSection />
      <CarriersSection />
      <KickstarterSection onNotifyClick={handleNotifyClick} />
      <FAQSection />
      <EcoSection />
      <Footer />

      {/* Sticky Bottom Bar for Mobile */}
      <StickyBottomBar onNotifyClick={handleNotifyClick} />

      <AuthModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)}
        onSuccess={handleAuthSuccess}
      />

      <KickstarterSubscribeModal
        isOpen={kickstarterModalOpen}
        onClose={() => setKickstarterModalOpen(false)}
      />
    </div>
  );
};

export default LandingPage;
